<template>
  <div class="d-flex flex-column flex-column-fluid">
    <!-- Toolbar -->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <div
        id="kt_app_toolbar_container"
        class="app-container container-fluid d-flex flex-stack"
      >
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <h1
            class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0"
          >
            منصة أكاديميا Academia
          </h1>
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <li class="breadcrumb-item text-muted">
              <a href="../../demo1/dist/index.html" class="text-muted text-hover-primary"
                >الصفحة الرئيسية</a
              >
            </li>
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <li class="breadcrumb-item text-muted">دوراتي</li>
          </ul>
        </div>
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!-- Additional actions here if needed -->
        </div>
      </div>
    </div>
    <!-- Content -->
    <!-- Bootstrap Modal -->
    <div
      class="modal fade"
      id="customCoursesModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="customCoursesModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="customCoursesModalLabel">الدورات المتاحة</h5>
            <button
              type="button"
              class="btn btn-secondary"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <i class="fa fa-close"></i>
            </button>
          </div>
          <div class="modal-body" style="min-height: 600px">
            <div class="row" style="height: 450px; overflow: scroll">
              <!-- رسالة عدم وجود دورات -->
              <div v-if="customCourses.length === 0 && !isLoadingCourses" class="col-12">
                <div
                  class="alert alert-warning text-center"
                  style="border-radius: 20px; margin: 20px"
                >
                  <b style="font-size: 23px">لايوجد دورات في هذا التخصص</b><br />
                  <i style="font-size: 120px" class="fa fa-alert"></i>
                </div>
              </div>

              <!-- عرض الدورات -->
              <div
                v-for="course in customCourses"
                :key="course.id"
                class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6"
              >
                <div class="card text-center">
                  <div class="card-body" style="padding: 5px">
                    <div class="m-1 blog__card--thumbnail">
                      <img
                        class="rounded"
                        :src="course.image"
                        @error="setDefaultImage"
                        alt="Course Thumbnail"
                      />
                    </div>
                    <h5 class="mt-3">
                      <a
                        class="text-success"
                        :href="`/course-details?id=${course.id}`"
                        style="font-size: 11px; font-weight: 800"
                      >
                        {{ course.title }}
                      </a>
                    </h5>
                    <small style="color: silver; font-weight: 700"
                      >{{ course.user.fname }} {{ course.user.lname }}</small
                    >
                    <div class="mt-2">
                      <template
                        v-if="
                          (course.price === null || course.price === 0) &&
                          course.discount_price === null
                        "
                      >
                        <h3 class="text-dark">مجاني</h3>
                      </template>
                      <template v-else-if="course.discount_price">
                        <h3 class="text-dark">{{ course.discount_price }} د.ل</h3>
                        <h4 class="text-muted text-decoration-line-through">
                          {{ course.price }} د.ل
                        </h4>
                      </template>
                      <template v-else>
                        <h3 class="text-dark">{{ course.price }} د.ل</h3>
                      </template>

                      <button
                        v-if="!allSelectedCourses.includes(course.id)"
                        style="padding: 6px"
                        class="btn btn-sm btn-success"
                        @click="addToSelectedCourses(course.id)"
                      >
                        إضافة إلى الباقة
                      </button>
                      <button
                        v-else
                        style="padding: 6px"
                        class="btn btn-sm btn-secondary"
                        @click="removeFromSelectedCourses(course.id)"
                      >
                        إزالة من الباقة
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <nav
                v-if="customCourseLinks && customCourseLinks.links"
                class="col-12 mt-3 d-flex justify-content-center"
              >
                <ul class="pagination">
                  <!-- Previous -->
                  <li
                    class="page-item"
                    :class="{ disabled: !customCourseLinks.links[0].url }"
                  >
                    <button
                      class="page-link"
                      style="font-weight: 700"
                      @click="
                        customCourseLinks.links[0].url &&
                          fetchCustomBundle(customCourseLinks.links[0].page)
                      "
                    >
                      &laquo; السابق
                    </button>
                  </li>

                  <!-- أرقام الصفحات المختصرة -->
                  <li
                    v-for="(link, index) in customCourseLinks.links.slice(
                      1,
                      customCourseLinks.links.length - 1
                    )"
                    :key="link.label"
                    v-if="index < 5 || index === customCourseLinks.links.length - 2"
                    class="page-item"
                    :class="{ active: link.active }"
                  >
                    <button
                      class="page-link"
                      @click="link.url && fetchCustomBundle(link.page)"
                    >
                      {{
                        index === 5 && customCourseLinks.links.length > 7
                          ? "..."
                          : link.label.replace(/&laquo;|&raquo;/g, "")
                      }}
                    </button>
                  </li>

                  <!-- Next -->
                  <li
                    class="page-item"
                    :class="{
                      disabled: !customCourseLinks.links[
                        customCourseLinks.links.length - 1
                      ].url,
                    }"
                  >
                    <button
                      class="page-link text-success"
                      style="font-weight: 700"
                      @click="
                        customCourseLinks.links[customCourseLinks.links.length - 1].url &&
                          fetchCustomBundle(
                            customCourseLinks.links[customCourseLinks.links.length - 1]
                              .page
                          )
                      "
                    >
                      التالي &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>

            <!-- الفاتورة أسفل الصفحة -->
            <div v-if="customCourses.length !== 0" class="invoice-section sticky-invoice">
              <div>
                <p>
                  السعر الإجمالي: {{ basePrice }}
                  <span class="badge badge-dark">الخصم : {{ applicableDiscount }}%</span>
                </p>
                <p>السعر الإجمالي بعد الخصم: {{ totalPrice.toFixed(2) }} د.ل</p>
              </div>
              <div class="text-center mt-4">
                <button
                  @click="confirmEnroll"
                  class="btn btn-sm btn-primary btn-lg"
                  :disabled="isLoading"
                >
                  <span v-if="isLoading"
                    ><i class="fa fa-spinner fa-spin"></i> الرجاء الإنتطار...</span
                  >
                  <span v-else> شراء الآن <i class="fa fa-check-circle"></i> </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Trigger Modal Button -->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <div id="kt_app_content_container" class="app-container container-fluid">
        <div class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="card">
            <div class="card-body">
              <ul
                class="nav nav-pills mb-3"
                style="display: flex; justify-content: center"
                id="pills-tab"
                role="tablist"
              >
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="pills-home-tab"
                    data-bs-toggle="pill"
                    href="#pills-home"
                    role="tab"
                    aria-controls="pills-home"
                    aria-selected="true"
                  >
                    باقات <i class="fas fa-book"></i
                  ></a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link active"
                    id="pills-profile-tab"
                    data-bs-toggle="pill"
                    href="#pills-profile"
                    role="tab"
                    aria-controls="pills-profile"
                    aria-selected="false"
                  >
                    الدورات <i class="fas fa-book-open"></i
                  ></a>
                </li>
                <li class="nav-item">
                  <a
                    class="nav-link"
                    id="pills-instructors-tab"
                    data-bs-toggle="pill"
                    href="#pills-instructors"
                    role="tab"
                    aria-controls="pills-instructors"
                    aria-selected="true"
                  >
                    محاضرين <i class="fas fa-users"></i
                  ></a>
                </li>
              </ul>
            </div>
            <!-- end card body -->
          </div>

          <div class="tab-content" id="pills-tabContent">
            <!-- Courses Tab -->

            <div
              class="tab-pane fade show active"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <button
                type="button"
                style="
                  margin-bottom: 30px;
                  width: 100%;
                  font-size: small;
                  font-weight: 700;
                  color: #00c630;
                  background: #0d7d3a14;
                  border: 2px solid #00c630;
                "
                class="btn btn-outline-success"
                data-bs-toggle="modal"
                data-bs-target="#customCoursesModal"
              >
                إصنع باقتك الخاصة الآن <i class="fa fa-plus"></i>
              </button>
              <div class="row g-5 g-xl-10 mb-5 mb-xl-10" id="coursesContainer">
                <div
                  v-if="isLoadingCourses"
                  class="d-flex justify-content-center align-items-center"
                >
                  <div class="spinner-border text-primary" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div
                  v-if="courses.length === 0 && isLoadingCourses == false"
                  class="col-12"
                >
                  <div
                    style="
                      border-radius: 20px;
                      padding: 10px;
                      color: #000;
                      background: #ffceaa;
                      margin: 20px;
                      text-align: center;
                    "
                  >
                    <b style="font-size: 23px">لايوجد دورات في هذا التخصص</b><br />
                    <i style="font-size: 120px" class="mdi mdi-alert-rhombus-outline"></i>
                  </div>
                </div>
                <div
                  v-for="course in courses"
                  :key="course.id"
                  class="col-xl-3 col-lg-3 col-md-3"
                >
                  <div class="card text-center">
                    <div class="card-body">
                      <div class="m-1 blog__card--thumbnail">
                        <img
                          class="rounded"
                          :src="`${course.image}`"
                          @error="setDefaultImage"
                          alt="Course Thumbnail"
                        />
                      </div>
                      <h5 class="mt-3">
                        <a
                          class="text-success"
                          :href="`/course-details?id=${course.id}`"
                          >{{ course.title }}</a
                        >
                      </h5>
                      <p class="text-muted">
                        {{ course.user.fname }} {{ course.user.lname }}
                      </p>
                      <div class="mt-2">
                        <h3>
                          <template
                            v-if="
                              (course.price === null || course.price === 0) &&
                              course.discount_price === null
                            "
                          >
                            <h3 class="text-success">مجاني</h3>
                          </template>
                          <template v-else-if="course.discount_price">
                            <h3 class="text-danger">{{ course.discount_price }} د.ل</h3>
                            <span class="text-muted text-decoration-line-through"
                              >{{ course.price }} د.ل</span
                            >
                            <span class="text-success"
                              >({{
                                calculateDiscountPercentage(
                                  course.price,
                                  course.discount_price
                                )
                              }}% تخفيض)</span
                            >
                          </template>
                          <template v-else>
                            <h3 class="text-success">{{ course.price }} د.ل</h3>
                          </template>
                        </h3>
                        <button
                          v-if="course.price != null || course.discount_price != null"
                          class="btn btn-success addtocart"
                          @click="addToCart(course.id, $event, 'course')"
                        >
                          إضافة إلى السلة <i class="fas fa-cart-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="pagination"></div>
            </div>
            <!-- Bundles Tab -->
            <div
              class="tab-pane fade"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <button
                type="button"
                style="
                  margin-bottom: 30px;
                  width: 100%;
                  font-size: small;
                  font-weight: 700;
                  color: #00c630;
                  background: #0d7d3a14;
                  border: 2px solid #00c630;
                "
                class="btn btn-outline-success"
                data-bs-toggle="modal"
                data-bs-target="#customCoursesModal"
              >
                إصنع باقتك الخاصة الآن <i class="fa fa-plus"></i>
              </button>
              <div class="row" id="bundleContainer">
                <div
                  v-if="isLoadingBundles"
                  class="d-flex justify-content-center align-items-center"
                >
                  <div class="spinner-border text-success" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
                <div v-if="bundles.length === 0 && !isLoadingBundles" class="col-12">
                  <div
                    style="
                      margin-bottom: 30px;
                      width: 100%;
                      border-radius: 20px;
                      padding: 10px;
                      color: #000;
                      background: #ffceaa;
                      margin: 20px;
                      text-align: center;
                    "
                  >
                    <b style="font-size: 23px">لايوجد باقات في هذا التخصص</b><br />
                    <i style="font-size: 120px" class="mdi mdi-alert-rhombus-outline"></i>
                  </div>
                </div>
                <div
                  v-for="bundle in bundles"
                  :key="bundle.id"
                  class="col-xl-3 col-lg-3 col-md-3"
                >
                  <div class="card text-center">
                    <div class="card-body">
                      <div class="m-1 blog__card--thumbnail">
                        <img
                          class="rounded"
                          :src="`${bundle.preview_image}`"
                          @error="setDefaultImage"
                          alt="Bundle Thumbnail"
                        />
                      </div>
                      <h5 class="mt-3">
                        <a
                          class="text-success"
                          :href="`/bundle-details?id=${bundle.id}`"
                          >{{ bundle.title }}</a
                        >
                      </h5>
                      <p class="text-muted">{{ bundle.user }}</p>
                      <div class="mt-2">
                        <h3>
                          <template
                            v-if="
                              (bundle.price === null || bundle.price === 0) &&
                              bundle.discount_price === null
                            "
                          >
                            <h3 class="text-success">مجاني</h3>
                          </template>
                          <template v-else-if="bundle.discount_price">
                            <h3 class="text-danger">{{ bundle.discount_price }} د.ل</h3>
                            <span class="text-muted text-decoration-line-through"
                              >{{ bundle.price }} د.ل</span
                            >
                            <span class="text-success"
                              >({{
                                calculateDiscountPercentage(
                                  bundle.price,
                                  bundle.discount_price
                                )
                              }}% تخفيض)</span
                            >
                          </template>
                          <template v-else>
                            <h3 class="text-success">{{ bundle.price }} د.ل</h3>
                          </template>
                        </h3>
                        <button
                          v-if="bundle.price != null || bundle.discount_price != null"
                          class="btn btn-success addtocart"
                          @click="addToCart(bundle.id, $event, 'bundle')"
                        >
                          إضافة إلى السلة <i class="fas fa-cart-plus"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div id="paginationBundle"></div>
            </div>
            <div
              class="tab-pane fade"
              id="pills-instructors"
              role="tabpanel"
              aria-labelledby="pills-instructors-tab"
            >
              <InstructorsList />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import "twbs-pagination";
import Swal from "sweetalert2";
import InstructorsList from "./InstructorsList.vue";
import { baseUrl, apiUrl } from "@/utils/api"; // Adjust the import path according to your project structure
import {
  showCart,
  addToCart,
  confirmPurchase,
  applyCoupon,
  removeCartItem,
  removeCoupon,
  generateCartInvoice,
} from "@/utils/cart";

export default {
  name: "CategoryCourses",
  components: {
    InstructorsList,
  },
  data() {
    return {
      customCourses: [], // قائمة الدورات
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
      courses: [],
      bundles: [],
      allCoursesCache: [], // لتخزين كل الكورسات التي تم تحميلها من كل الصفحات

      selectedCourseIds: [], // الدورات المختارة
      discounts: [], // خصومات
      minCourses: 0,
      maxCourses: 0,
      isLoadingCourses: true,
      isLoadingBundles: true,
      isLoading: false,
      defaultImage: "/assets/img/acad-icon.png",

      // Paginator جديد للدورات
      customCoursePagination: {},
      customCourseLinks: [],
      currentCustomCoursePage: 1,

      totalCoursesPages: 0,
      totalBundlesPages: 0,
      currentPage: 1,
      coursesPerPage: 20,
      bundlesPerPage: 20,
      baseUrl: baseUrl,
      allSelectedCourses: [], // لتخزين كل الدورات المختارة عبر الصفحات

      isLoadingCourses: true,
      isLoadingBundles: true,
      isInitialCoursesFetch: true, // Flag to check initial fetch
      isInitialBundlesFetch: true, // Flag to check initial fetch
    };
  },

  mounted() {
    this.fetchCourses(this.currentPage);
    this.fetchBundles(this.currentPage);
    this.fetchCustomBundle();
  },
  methods: {
    async confirmEnroll() {
      // عرض رسالة تأكيد قبل بدء عملية الاشتراك
      const result = await Swal.fire({
        title: "هل أنت متأكد أنك تريد الاشتراك في هذه الدورات؟",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "نعم، اشتراك",
        cancelButtonText: "إلغاء",
      });

      // إذا ضغط المستخدم على "نعم"
      if (result.isConfirmed) {
        this.enrollInCourses(); // استدعاء دالة الاشتراك
      }
    },

    async enrollInCourses() {
      this.isLoading = true; // تشغيل اللودر عند بدء الاشتراك
      try {
        // تحقق من أن هناك دورات محددة للتسجيل فيها
        if (this.allSelectedCourses.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "يرجى إختيار دورات للإشتراك أولاً",
            text: "",
            confirmButtonText: "موافق",
          });
          this.isLoading = false; // إيقاف اللودر إذا لم يتم تحديد دورات
          return;
        }

        const urlParams = new URLSearchParams(window.location.search);
        const value_id = urlParams.get("value_id");
        const value = urlParams.get("value");

        // بيانات الطلب
        const enrollmentData = {
          courses_ids: this.allSelectedCourses, // استخدام allSelectedCourses الآن
        };

        if (value_id === "subcategory_id") {
          enrollmentData.subcategory_id = value;
        } else if (value_id === "childcategory_id") {
          enrollmentData.childcategory_id = value;
          const sub = urlParams.get("sub");
          if (sub) enrollmentData.subcategory_id = sub; // إضافة sub_category إذا موجود
        }

        // إرسال الطلب
        const response = await fetch(`${apiUrl}/custom-bundles/enroll`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": "+218",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(enrollmentData),
        });

        // التحقق من استجابة الطلب
        const result = await response.json(); // الحصول على محتوى الاستجابة

        if (!response.ok) {
          let errorMessage = "فشل عملية الإشتراك ، الرجاء التأكد وإعادة المحاولة";
          if (result.message) {
            errorMessage = result.message;
          }
          Swal.fire({
            icon: "error",
            title: errorMessage,
            text: "",
            confirmButtonText: "موافق",
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "تم الشراء بنجاح",
            text: "نتمنى لك التوفيق",
          }).then((result) => {
            if (result.isConfirmed) {
              location.reload();
            }
          });
        }
      } catch (error) {
        console.error("Error enrolling in courses:", error);
        Swal.fire({
          icon: "error",
          title: "فشل عملية الإشتراك ، الرجاء التأكد وإعادة المحاولة",
          text: "",
          confirmButtonText: "موافق",
        });
      } finally {
        this.isLoading = false; // إيقاف اللودر بعد انتهاء العملية
      }
    },

    calculateDiscountPercentage(price, discountPrice) {
      if (price > 0) {
        return Math.round(((price - discountPrice) / price) * 100);
      }
      return 0;
    },
    async fetchCourses(page) {
      this.isLoadingCourses = true;
      const urlParams = new URLSearchParams(window.location.search);
      const value_id = urlParams.get("value_id");
      const value = urlParams.get("value");
      const data = {
        page: page,
        limit: this.coursesPerPage,
      };

      if (value_id === "category_id") {
        data.category_id = value;
      } else if (value_id === "subcategory_id") {
        data.subcategory_id = value;
      } else if (value_id === "childcategory_id") {
        data.childcategory_id = value;
      }

      try {
        const response = await fetch(`${apiUrl}/web/get-courses`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": "+218",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(data),
        });

        const result = await response.json();
        const resData = result.courses;
        this.courses = resData.data;
        this.totalCoursesPages = Math.ceil(resData.meta.total / resData.meta.per_page);
        this.initializeCoursesPagination(this.totalCoursesPages);
      } catch (error) {
        console.log("Error:", error);
      } finally {
        this.isLoadingCourses = false;
      }
    },
    async fetchBundles(page) {
      this.isLoadingBundles = true;
      const urlParams = new URLSearchParams(window.location.search);
      const value_id = urlParams.get("value_id");
      const value = urlParams.get("value");
      const data = {
        page: page,
        limit: this.bundlesPerPage,
      };

      if (value_id === "category_id") {
        data.category_id = value;
      } else if (value_id === "subcategory_id") {
        data.subcategory_id = value;
      } else if (value_id === "childcategory_id") {
        data.childcategory_id = value;
      }

      try {
        const response = await fetch(`${apiUrl}/web/get-bundles`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "x-country-code": "+218",
            Authorization: `Bearer ${this.token}`,
          },
          body: JSON.stringify(data),
        });

        const result = await response.json();
        const resData = result.bundle;
        this.bundles = resData;
        this.totalBundlesPages = Math.ceil(resData.meta.total / resData.meta.per_page);
        this.initializeBundlesPagination(this.totalBundlesPages);
      } catch (error) {
        console.log("Error:", error);
      } finally {
        this.isLoadingBundles = false;
      }
    },
    async fetchCustomBundle(page = 1) {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const value_id = urlParams.get("value_id");
        const value = urlParams.get("value");
        const data = { page }; // أضف page للـ paginate

        if (value_id === "subcategory_id") {
          data.sub_category_id = value;
        } else if (value_id === "childcategory_id") {
          data.child_category_id = value;
          const sub = urlParams.get("sub");
          data.sub_category_id = sub;
        }

        const response = await fetch(`${apiUrl}/web/get-customizable-courses`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.token}`,
            "x-country-code": "+218",
          },
          body: JSON.stringify(data),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch course details");
        }

        const result = await response.json();
        result.courses.data.forEach((course) => {
          if (!this.allCoursesCache.some((c) => c.id === course.id)) {
            this.allCoursesCache.push(course);
          }
        });
        // تحديث customCourses بالـ data
        this.customCourses = result.courses.data;
        this.discounts = result.discounts;

        // تحديث min/max courses
        this.minCourses = result.sub_category.min_courses;
        this.maxCourses = result.sub_category.max_courses;

        // تحديث بيانات الـ paginate الخاصة بالدورات
        this.customCoursePagination = result.courses.meta;
        this.customCourseLinks = result.courses.meta;
        this.currentCustomCoursePage = result.courses.meta.current_page;

        console.log("Courses:", this.customCourses);
        console.log("Pagination Links:", this.customCourseLinks);
      } catch (error) {
        console.error("Error fetching course details:", error);
      } finally {
        this.isLoadingCourses = false;
      }
    },

    addToSelectedCourses(courseId) {
      if (this.allSelectedCourses.includes(courseId)) return;
      if (this.allSelectedCourses.length >= this.maxCourses) {
        Swal.fire({
          icon: "warning",
          title: `لقد وصلت إلى الحد الأقصى (${this.maxCourses}) من الدورات. الرجاء إزالة دورة لإضافة أخرى.`,
          text: "",
          confirmButtonText: "موافق",
        });
      } else {
        this.allSelectedCourses.push(courseId);
      }
    },

    removeFromSelectedCourses(courseId) {
      this.allSelectedCourses = this.allSelectedCourses.filter((id) => id !== courseId);
    },

    initializeCoursesPagination(totalPages) {
      if (this.$coursesPagination) {
        this.$coursesPagination.destroy();
      }

      this.$nextTick(() => {
        $("#pagination").twbsPagination({
          totalPages: totalPages,
          visiblePages: 5,
          first: "الأول",
          prev: "السابق",
          next: "التالي",
          last: "الأخير",
          onPageClick: (event, page) => {
            // Only fetch courses if this is not the initial fetch
            if (!this.isInitialCoursesFetch) {
              this.fetchCourses(page);
            }
            this.isInitialCoursesFetch = false;
          },
        });
      });
      this.isLoadingCourses = false;
    },
    initializeBundlesPagination(totalPages) {
      if (this.$bundlesPagination) {
        this.$bundlesPagination.destroy();
      }

      this.$nextTick(() => {
        $("#paginationBundle").twbsPagination({
          totalPages: totalPages,
          visiblePages: 5,
          first: "الأول",
          prev: "السابق",
          next: "التالي",
          last: "الأخير",
          onPageClick: (event, page) => {
            // Only fetch bundles if this is not the initial fetch
            if (!this.isInitialBundlesFetch) {
              this.fetchBundles(page);
            }
            this.isInitialBundlesFetch = false;
          },
        });
      });
    },
    showCart,
    addToCart,
    removeCartItem,
    setDefaultImage(event) {
      event.target.src = this.defaultImage;
    },
  },
  computed: {
    totalCourses() {
      return this.allSelectedCourses.length;
    },
    applicableDiscount() {
      const discountObj = this.discounts.find(
        (discount) => discount.number_of_courses == this.totalCourses
      );
      return discountObj ? parseFloat(discountObj.discount) : 0;
    },
    basePrice() {
      const basePrice = this.allSelectedCourses.reduce((total, courseId) => {
        // ابحث في جميع الصفحات المختارة
        let course = this.customCourses.find((c) => c.id === courseId);
        if (!course) {
          // إذا الدورة ليست في الصفحة الحالية، ابحث عنها في allCoursesCache
          course = this.allCoursesCache.find((c) => c.id === courseId);
        }
        if (!course) return total;
        const coursePrice = course.discount_price
          ? parseFloat(course.discount_price)
          : parseFloat(course.price);
        return total + coursePrice;
      }, 0);
      return basePrice;
    },
    totalPrice() {
      const basePrice = this.basePrice;
      const discountAmount = (basePrice * this.applicableDiscount) / 100;
      return basePrice - discountAmount;
    },
  },
};
</script>

<style scoped>
/* Add your scoped CSS here */
</style>
